// @unocss-include

const logos = _.mapKeys(
  import.meta.glob('../assets/logo-*.png', { eager: true, as: 'url' }),
  (value, key) => key.slice(15, -4)
)

const brands = {
  m10: {
    id: 'm10',
    name: 'Medicare10',
    url: 'Medicare10.com',
    owner: 'Easy Health Insurance Services, LLC',
    phone: '18335732845',
    favicon: '/favicon.ico',
    measurementId: '6SZWQRZN9W',
    address: '8605 Santa Monica Blvd, PMB 38903, West Hollywood, CA 90069',
    logo: {
      url: logos.m10,
      class: 'h-12 md:h-14 w-auto',
      width: 412,
      height: 88,
    },
    logoSmall: {
      url: logos.small,
      class: 'h-8 md:h-10',
    },
  },
  ayb: {
    id: 'ayb',
    name: 'Activate Your Benefits',
    url: 'ActivateYourBenefits.org',
    owner: 'AYB Co',
    phone: '18663291920',
    favicon: '/favicon.ico',
    measurementId: null,
    address: '8605 Santa Monica Blvd, PMB 38903, West Hollywood, CA 90069',
    logo: {
      url: logos.ayb,
      class: 'h-12 md:h-14 w-auto',
    },
    logoSmall: {
      url: logos.small,
      class: 'h-8 md:h-10',
    },
  },
  bh: {
    id: 'bh',
    name: 'Benefit Helpline',
    url: 'Benefit-Helpline.com',
    owner: 'Easy Health Insurance Services, LLC',
    phone: '18557571250',
    favicon: '/favicon-bh.ico',
    measurementId: 'F3SR0GE0JN',
    address: '8605 Santa Monica Blvd, PMB 38903, West Hollywood, CA 90069',
    logo: {
      url: logos.bh,
      class: 'h-12 md:h-20 w-auto',
    },
    logoSmall: {
      url: logos['small-bh'],
      class: 'h-8 md:h-10',
    },
  },
  med10: {
    id: 'med10',
    name: 'Med10',
    url: 'Med10.org',
    owner: 'Easy Health Insurance Services, LLC',
    phone: '18335732845',
    favicon: '/favicon.ico',
    measurementId: 'FPLT66V8WB',
    address: '8605 Santa Monica Blvd, PMB 38903, West Hollywood, CA 90069',
    logo: {
      url: logos.med10,
      class: 'h-14 w-auto',
    },
    logoSmall: {
      url: logos.small,
      class: 'h-8 md:h-10',
    },
  },
  boomer: {
    id: 'boomer',
    name: 'This Boomer',
    url: 'ThisBoomer.com',
    owner: 'Boomer Media Co',
    phone: '18444151627',
    favicon: '/favicon-boomer.ico',
    address: '8605 Santa Monica Blvd, PMB 38903, West Hollywood, CA 90069',
    measurementId: null,
    logo: {
      url: logos.boomer,
      class: 'h-12 md:h-14 w-auto',
    },
    logoSmall: {
      url: logos['small-boomer'],
      class: 'h-8 md:h-10',
    },
  },
  bridge: {
    id: 'bridge',
    name: 'General Medicare',
    owner: 'General Medicare Co',
    url: 'General-Medicare.com',
    phone: '18335732845',
    favicon: '/favicon-general.ico',
    measurementId: 'F3SR0GE0JN',
    address: '77 Sands 6th Floor, Brooklyn, NY 11201',
    logo: {
      url: logos.bridge,
      class: 'h-12 md:h-14 w-auto',
      width: 412,
      height: 88,
    },
    logoSmall: {
      url: logos['small-bridge'],
      class: 'h-8 md:h-10',
    },
  },
  ac: {
    id: 'ac',
    name: 'AllowanceCards.com',
    url: 'AllowanceCards.com',
    owner: 'Healthy Labs Inc',
    phone: '18335732845',
    favicon: '/favicon-ac.ico',
    address: '8605 Santa Monica Blvd, PMB 38903, West Hollywood, CA 90069',
    measurementId: null,
    logo: {
      url: logos.ac,
      class: 'h-12 md:h-14 w-auto',
      width: 479,
      height: 59,
    },
    logoSmall: {
      url: logos.small,
      class: 'h-8 md:h-10',
    },
  },
  sd: {
    id: 'sd',
    name: 'SeniorDeals',
    url: 'SeniorDeals.com',
    owner: 'Senior Deals Company',
    phone: '18335732845',
    favicon: '/favicon-sd.ico',
    address: '77 Sands 6th Floor, Brooklyn, NY 11201',
    measurementId: null,
    logo: {
      url: logos.sd,
      class: 'h-12 md:h-14 w-auto',
      width: 479,
      height: 59,
    },
    logoSmall: {
      url: logos['small-sd'],
      class: 'h-8 md:h-10',
    },
  },
}

export const brand = brands[__BRAND__]
